import { TableCell, styled } from "@mui/material";

import { palette } from "~frontend/theme";

export const StatusTableHeaderCell = styled(TableCell)({
  color: palette.darkGray,
  fontSize: "12px",
  paddingBottom: "0",
  fontWeight: 500,
  borderBottomWidth: "2px",
});
